import { render, staticRenderFns } from "./uploadimage-button.vue?vue&type=template&id=5fcc9abb&scoped=true&"
import script from "./uploadimage-button.vue?vue&type=script&lang=js&"
export * from "./uploadimage-button.vue?vue&type=script&lang=js&"
import style0 from "./uploadimage-button.vue?vue&type=style&index=0&id=5fcc9abb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc9abb",
  null
  
)

export default component.exports